import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { Component } from "react";
import Home from "./Home";
import AppTheme from "../src/shared-theme/AppTheme.js";
import "mapbox-gl/dist/mapbox-gl.css";
import SignIn from "./SignIn.js";
import IssuesHome from "./IssuesHome.js";
import ProtectedRoute from "./ProtectedRoute";

import { CssBaseline } from "@mui/material";
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from "../src/theme/customizations";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default class App extends Component {
  render() {
    return (
      <AppTheme
        {...this.props}
        disableCustomTheme={false}
        themeComponents={xThemeComponents}
      >
        <CssBaseline />
        <Router>
          <Routes>
            <Route path="/" element={<SignIn />} />

            <Route
              path="/D66"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />

            <Route
              path="/issues"
              element={
                <ProtectedRoute>
                  <IssuesHome />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </AppTheme>
    );
  }
}
